import { useState, useEffect } from "react";
import { getLocalStorage, setLocalStorage, LOCAL_STORAGE_KEYS } from "@shared/constants";
import { Modal, Input, Select } from "barte-design-system";
import { DevToLogoIcon } from "@phosphor-icons/react";

import { INITIAL_FORM_DATA } from "./dev-tools.constants";
import type { DevToolsFormData } from "./dev-tools.type";
import styles from "./dev-tools.module.css";

export const DevTools = () => {
  const isDev = import.meta.env.DEV;

  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState<DevToolsFormData>(INITIAL_FORM_DATA);

  const handleChange = (name: keyof DevToolsFormData, value: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleApply = () => {
    Object.entries(formData).forEach(([key, value]) => {
      if (value != null && value !== "") {
        setLocalStorage(key as keyof typeof LOCAL_STORAGE_KEYS, value);
      }
    });

    setIsOpen(false);
    window.location.reload();
  };

  useEffect(() => {
    if (isOpen) {
      setFormData({
        userApiToken: getLocalStorage("userApiToken") || "",
        userBearerToken: getLocalStorage("userBearerToken") || "",
        userEmail: getLocalStorage("userEmail") || "",
        userType: getLocalStorage("userType") || "",
        companyId: getLocalStorage("companyId") || "",
        companyName: getLocalStorage("companyName") || "",
      });
    }
  }, [isOpen]);

  if (!isDev) {
    return null;
  }

  return (
    <>
      <button
        className={styles["floating-button"]}
        onClick={() => setIsOpen(true)}
        title="Dev Tools"
      >
        <DevToLogoIcon size={32} />
      </button>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Modo Desenvolvedor"
        size="sm"
        footer={{
          primaryButton: {
            children: "Aplicar e Recarregar",
            onClick: handleApply,
          },
          secondaryButton: {
            children: "Cancelar",
            variant: "outline",
            onClick: () => setIsOpen(false),
          },
          buttonLayout: "hug",
        }}
      >
        <div className={styles["form-wrapper"]}>
          <Input
            label="companyId"
            value={formData.companyId}
            onChange={(e: any) =>
              handleChange("companyId", e?.target ? e.target.value : e)
            }
          />

          <Input
            label="companyName"
            value={formData.companyName}
            onChange={(e: any) =>
              handleChange("companyName", e?.target ? e.target.value : e)
            }
          />

          <Input
            label="userApiToken"
            value={formData.userApiToken}
            onChange={(e: any) =>
              handleChange("userApiToken", e?.target ? e.target.value : e)
            }
          />

          <Input
            label="userBearerToken"
            value={formData.userBearerToken}
            onChange={(e: any) =>
              handleChange("userBearerToken", e?.target ? e.target.value : e)
            }
          />

          <Input
            label="userEmail"
            value={formData.userEmail}
            onChange={(e: any) =>
              handleChange("userEmail", e?.target ? e.target.value : e)
            }
          />

          <Select
            label="userType"
            value={formData.userType}
            options={[
              { value: "seller", label: "seller" },
              { value: "admin", label: "admin" },
            ]}
            hidePrefixIcon
            onChange={(value: string) => handleChange("userType", value)}
          />
        </div>
      </Modal>
    </>
  );
};
